import { useAppSelector } from 'app/hooks';
import AccordionSection from 'components/layout/accordion-section';
import useFetchedConfigurations from 'hooks/use-fetched-configurations';
import { SystemListFilterState } from './equipment-comparison-filters';
import { toggleSetValue } from './equipment-filter-helpers';
import FilterSection from './equipment-filter-section';
import { FilterOption } from './equipment-filter-section-types';

type EquipmentConfigFilterProps = Readonly<{
  state: SystemListFilterState;
  onChange: (next: SystemListFilterState) => void;
}>;

export default function EquipmentConfigFilter({
  state,
  onChange
}: EquipmentConfigFilterProps) {
  const configurations = useFetchedConfigurations();
  const { systemCombinationsFull, combinationPaginationByConfig } =
    useAppSelector((storeState) => storeState.systems);

  if (configurations.length < 2) return null;

  const configOptions: FilterOption<string>[] = configurations.map((config) => {
    const count = systemCombinationsFull[config.uniqueId]?.length ?? 0;
    const total = combinationPaginationByConfig[config.uniqueId]?.total;
    const description =
      total !== undefined && total > count
        ? `${count} of ${total} systems`
        : `${count} system${count === 1 ? '' : 's'}`;
    return {
      value: config.uniqueId,
      htmlId: `equipment-filter-config-${config.uniqueId}`,
      label: config.name || 'Configuration',
      description
    };
  });

  const badge =
    state.configIds.size < configurations.length ? state.configIds.size : null;

  return (
    <AccordionSection title='Configurations' badge={badge} defaultOpen>
      <FilterSection
        options={configOptions}
        enabled={state.configIds}
        onToggle={(id) =>
          onChange({
            ...state,
            configIds: toggleSetValue(state.configIds, id)
          })
        }
      />
    </AccordionSection>
  );
}
